__turbopack_context__.v({
  "applyButton": "DemoDayListPage-module-scss-module__Pkcbtq__applyButton",
  "bottom": "DemoDayListPage-module-scss-module__Pkcbtq__bottom",
  "break": "DemoDayListPage-module-scss-module__Pkcbtq__break",
  "buttons": "DemoDayListPage-module-scss-module__Pkcbtq__buttons",
  "content": "DemoDayListPage-module-scss-module__Pkcbtq__content",
  "dot": "DemoDayListPage-module-scss-module__Pkcbtq__dot",
  "footer": "DemoDayListPage-module-scss-module__Pkcbtq__footer",
  "footerButtons": "DemoDayListPage-module-scss-module__Pkcbtq__footerButtons",
  "footerLink": "DemoDayListPage-module-scss-module__Pkcbtq__footerLink",
  "headline": "DemoDayListPage-module-scss-module__Pkcbtq__headline",
  "headlineBody": "DemoDayListPage-module-scss-module__Pkcbtq__headlineBody",
  "headlineTitle": "DemoDayListPage-module-scss-module__Pkcbtq__headlineTitle",
  "heroSection": "DemoDayListPage-module-scss-module__Pkcbtq__heroSection",
  "infoLink": "DemoDayListPage-module-scss-module__Pkcbtq__infoLink",
  "infoText": "DemoDayListPage-module-scss-module__Pkcbtq__infoText",
  "label": "DemoDayListPage-module-scss-module__Pkcbtq__label",
  "labelText": "DemoDayListPage-module-scss-module__Pkcbtq__labelText",
  "linkButton": "DemoDayListPage-module-scss-module__Pkcbtq__linkButton",
  "links": "DemoDayListPage-module-scss-module__Pkcbtq__links",
  "logoText": "DemoDayListPage-module-scss-module__Pkcbtq__logoText",
  "logos": "DemoDayListPage-module-scss-module__Pkcbtq__logos",
  "logosAndButton": "DemoDayListPage-module-scss-module__Pkcbtq__logosAndButton",
  "logosButtonContainer": "DemoDayListPage-module-scss-module__Pkcbtq__logosButtonContainer",
  "overline": "DemoDayListPage-module-scss-module__Pkcbtq__overline",
  "overlineText": "DemoDayListPage-module-scss-module__Pkcbtq__overlineText",
  "partnersLink": "DemoDayListPage-module-scss-module__Pkcbtq__partnersLink",
  "partnersSection": "DemoDayListPage-module-scss-module__Pkcbtq__partnersSection",
  "root": "DemoDayListPage-module-scss-module__Pkcbtq__root",
  "section1": "DemoDayListPage-module-scss-module__Pkcbtq__section1",
  "section2": "DemoDayListPage-module-scss-module__Pkcbtq__section2",
  "sectionFaq": "DemoDayListPage-module-scss-module__Pkcbtq__sectionFaq",
  "sectionPartners": "DemoDayListPage-module-scss-module__Pkcbtq__sectionPartners",
  "subtitle": "DemoDayListPage-module-scss-module__Pkcbtq__subtitle",
  "title": "DemoDayListPage-module-scss-module__Pkcbtq__title",
});
